import { render, staticRenderFns } from "./fendt.vue?vue&type=template&id=10e04d46&"
import script from "./fendt.vue?vue&type=script&lang=js&"
export * from "./fendt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports